import React, {  Suspense, useEffect} from 'react';
import { Route, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import {ToastContainer} from 'react-toastify';
import get from "lodash/get";
import PrivateRouteWithShops from '../../Components/PrivateRouteWithShops'
import Preloader from '../../Components/Preloader'
import AuthTokenAuthorizationWrapper from '../../Pages/Auth/Components/AuthTokenAuthorizationWrapper';
import {SHOP_SOURCE_ONE_MESSAGE} from "../../constants";
import DownloadApplication from "../../Pages/Auth/DownloadApplication";
import NotFound from "../../Pages/Auth/NotFound";
import Dashboard from "../../Pages/Main/Dashboard";
import Flows from "../../Pages/Main/Flow/Flows";
import Chats from "../../Pages/Chats";
import BotUsers from "../../Pages/Audience/BotUsers";
import Groups from "../../Pages/Audience/Groups";
import Leads from "../../Pages/Audience/Leads";
import Keywords from "../../Pages/Automation/Keywords";
import Triggers from "../../Pages/Automation/Triggers";
import Common from "../../Pages/Settings/Common";
import CustomFields from "../../Pages/Settings/CustomFields";
import Tags from "../../Pages/Settings/Tags";
import NotificationChannels from "../../Pages/Settings/NotificationChannels";
import InstallPlugin from "../../Pages/Settings/Plugins/InstallPlugin";
import Plugins from "../../Pages/Settings/Plugins";
import LiveChat from "../../Pages/Settings/LiveChat";
import Team from "../../Pages/Settings/Team";
import PersonalSettings from "../../Pages/Settings/PersonalSettings";
import PaymentGates from "../../Pages/Settings/PaymentGates";
import HSMTemplates from "../../Pages/Settings/HSMTemplates";
import Auth from "../../Pages/Auth";


const AppMain = (
    {
        activeShop,
        isAuthenticated,
    }
) => {

    // const tagManagerArgs = {
    //     gtmId: process.env.REACT_APP_GTM_ID,
    // };
    //
    useEffect(() => {

        // // Initialize only in web browser
        // if (typeof document !== 'undefined') {
        //     TagManager.initialize(tagManagerArgs);
        // }
    }, []);

    return <AuthTokenAuthorizationWrapper>
        {/* Auth */}
        <Suspense fallback={<Preloader/>}>
            <Switch>
                <Route exact path="/app/acceptInvite" component={DownloadApplication}/>


                {/*<Route path="/auth" component={Auth}/>*/}


                {/*/!* Main menu *!/*/}

                    <PrivateRouteWithShops
                        path="/:shopId/dashboard/"
                        component={Dashboard}
                    />


                    <PrivateRouteWithShops
                        path="/:shopId/flows/"
                        component={Flows}
                    />


                {/* Audience */}

                    <PrivateRouteWithShops
                        path="/:shopId/chats/"
                        component={Chats}
                    />

                    <PrivateRouteWithShops
                        path="/:shopId/audience/bot_users/"
                        component={BotUsers}
                    />

                    <PrivateRouteWithShops
                        path="/:shopId/audience/groups/"
                        component={Groups}
                    />

                    <PrivateRouteWithShops
                        path="/:shopId/audience/leads/"
                        component={Leads}
                    />


                {/*/!* Broadcasts *!/*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/broadcasts/tasks/"*/}
                {/*        component={BroadcastTasks}*/}
                {/*    />*/}
                {/*</Suspense>*/}

                {/*/!* Growth *!/*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/growth/short_links/"*/}
                {/*        component={ShortLinks}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/growth/website_icon_links/"*/}
                {/*        component={WebsiteIconLinks}*/}
                {/*    />*/}
                {/*</Suspense>*/}

                {/*/!* Automation *!/*/}

                    <PrivateRouteWithShops
                        path="/:shopId/automation/keywords/"
                        component={Keywords}
                    />

                    <PrivateRouteWithShops
                        path="/:shopId/automation/triggers/"
                        component={Triggers}
                    />

                {/*/!* Catalog *!/*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/catalog/categories/"*/}
                {/*        component={Categories}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/catalog/products/"*/}
                {/*        component={Products}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/catalog/orders/"*/}
                {/*        component={Orders}*/}
                {/*    />*/}
                {/*</Suspense>*/}

                {/*/!* Settings *!/*/}

                    <PrivateRouteWithShops
                        path="/:shopId/settings/common/"
                        component={Common}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/custom_fields/"
                        component={CustomFields}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/tags/"
                        component={Tags}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/notifications/"
                        component={NotificationChannels}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/plugins/connect/:slug/"
                        component={InstallPlugin}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/plugins/"
                        component={Plugins}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/live_chat/"
                        component={LiveChat}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/team/"
                        component={Team}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/waba_templates/"
                        component={HSMTemplates}
                    />
                    <PrivateRouteWithShops
                        path="/:shopId/settings/payment_gates/"
                        component={PaymentGates}
                    />

                    <PrivateRouteWithShops
                        path="/:shopId/settings/personal_settings/"
                        component={PersonalSettings}
                    />


                {/*/!* ConnectBot *!/*/}

                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/vk/"*/}
                {/*        component={VKGroups}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/telegram/"*/}
                {/*        component={TGBot}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/whatsapp/"*/}
                {/*        component={WhatsApp}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/waba/"*/}
                {/*        component={WABA}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/avito/"*/}
                {/*        component={AvitoBot}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/viber/"*/}
                {/*        component={ViberBot}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/facebook/"*/}
                {/*        component={FacebookPages}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/facebook_permissions_required/"*/}
                {/*        component={FacebookPermissionsRequired}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/ok/"*/}
                {/*        component={OKGroup}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/instagram/"*/}
                {/*        component={Instagram}*/}
                {/*    />*/}
                {/*</Suspense>*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <PrivateRouteWithShops*/}
                {/*        path="/:shopId/connect/express/"*/}
                {/*        component={ExpressBot}*/}
                {/*    />*/}
                {/*</Suspense>*/}

                {/*/!* Дополнительные элементы *!/*/}
                {/*<Suspense fallback={<Preloader/>}>*/}
                {/*    <UpgradeToPRO/>*/}
                {/*</Suspense>*/}

                <Route path="*" component={NotFound}/>
            </Switch>
        </Suspense>
        <ToastContainer/>
    </AuthTokenAuthorizationWrapper>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(AppMain);
